// Generated by CoffeeScript 2.7.0
var EditYawPushPackageModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import PayLoadItem from './pay_load_item.js';

export default EditYawPushPackageModal = Vue.extend({
  components: {
    modal: Modal,
    'pay-load-item': PayLoadItem
  },
  props: {
    vertex: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    return {
      pushPackage: []
    };
  },
  watch: {
    vertex: {
      handler: function(value) {
        return this.pushPackage = value.push_settings || [];
      },
      immediate: true
    }
  },
  template: `<modal ref='modal'
       title='设置节点推送'
       :backdrop='true'
       extendClass='push-package-modal'
       @ensureClicked="ensureClickedFunc">
  <template>
    <div v-if="pushPackage.length > 0" class="mt-5 modal-body yaw-push-package">
      <div class="justify-between inline mb-4 form-field-group add-push-btn">
        <div class="text-strong bold-text">推送任务</div>
        <button class="outlined btn-primary"
                @click="addPayloadFunc">
          <i class="slp-plus-circle"></i>
          <span>新增推送任务</span>
        </button>
      </div>
      <div class="p-12 justify-box light-gray-text yaw-push-package-header">
        <div>序号</div>
        <div>推送时刻</div>
        <div>推送时间</div>
        <div>推送方式</div>
        <div>推送范围或URL</div>
        <div>操作</div>
      </div>
      <pay-load-item v-for="(payload, index) in pushPackage"
                     :key="index"
                     :initialPayload='payload'
                     :index='index'
                     @payloadChanged='payloadChangedFunc'
                     @deletedPayload='deletedPayloadFunc'
                     >
      </pay-load-item>
    </div>
    <div v-else class="mt-5 modal-body yaw-push-package justify-box">
      <i class="slp-message-box-o placeholder-icon" />
      <div class="mt-5 mb-4 gray-text">暂无数据</div>
      <button class="outlined btn-primary"
              @click="addPayloadFunc">
        <i class="slp-plus-circle"></i>
        <span>新增推送任务</span>
      </button>
    </div>
  </template>
</modal>`,
  methods: {
    addPayloadFunc: function() {
      return this.pushPackage.push({
        push_type: 'Push::CustomMessage',
        push_time: 'created',
        push_scope: 'review',
        waiting: 0
      });
    },
    deletedPayloadFunc: function(index, payload) {
      return this.pushPackage.splice(index, 1);
    },
    payloadChangedFunc: function(index, payload) {
      return this.pushPackage[index] = payload;
    },
    ensureClickedFunc: function() {
      return this.$emit('ensureClicked', this.pushPackage);
    },
    updateSettings: function(settings) {
      return _.extend(this, settings);
    },
    open: function() {
      return this.$refs.modal.open();
    }
  }
});
